import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { NavgationPageLocationKey } from "../../../utils/constants";
import Multiselect from "multiselect-react-dropdown";
import ReactTable from "react-table";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  DatePicker,
  Form,
  FormInput,
  FormSelect,
  FormTextarea,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from "shards-react";
import classNames from "classnames";
import CustomModal from "../../../components/common/CustomModal";
import { setDateForTable, setDateForTableInHrMinSec, setInputDate } from "../../../utils/date";
import { setAlert } from "../../../redux/actions/alert";
import {
  bulk_action_change_request,
  get_change_request_bulk_actions,
  get_change_request_list,
  get_change_request_status_list,
} from "../../../redux/actions/subscriber/changeRequest";

const STATUS_ALL = "All";
const STATUS_REQUESTED = "Requested";

const initialState = {
  pageSizeOptions: [5, 10, 15, 20, 25, 30],
  pageSize: 10,
  refNum: "",
  clientId: "",
  clientName: "",
  workerId: "",
  workerName: "",
  completedBy: "",
  from: "",
  to: "",
  bulkAction: "",
};

const getStatusClass = (status = "") => {
  const normalized = status.toLowerCase();
  if (normalized.includes("reject")) return "status-red";
  if (normalized.includes("request") || normalized.includes("pending")) {
    return "status-orange";
  }
  return "status-green";
};

const ChangeRequestList = ({
  changeRequestList,
  changeRequestStatusList,
  changeRequestBulkActions,
  get_change_request_list,
  get_change_request_status_list,
  get_change_request_bulk_actions,
  bulk_action_change_request,
  setAlert,
}) => {
  const [state, setState] = useState({ ...initialState });
  const [tableData, setTableData] = useState([]);
  const [statusDropdownOptions, setStatusDropdownOptions] = useState([]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [note, setNote] = useState("");

  function openChangeRequestInNewTab(e, refId, clientName, workerName) {
    e.preventDefault();
    localStorage.setItem(
      NavgationPageLocationKey.ChangeRequestCurrentAddEdit,
      JSON.stringify({ refNum: refId, clientName: clientName || "", workerName: workerName || "" })
    );
    window.open('/change-request', '_blank');
  }

  function onContextMenuChangeRequest(e, refId, clientName, workerName) {
    if (e.type === 'contextmenu') {
      localStorage.setItem(
        NavgationPageLocationKey.ChangeRequestCurrentAddEdit,
        JSON.stringify({ refNum: refId, clientName: clientName || "", workerName: workerName || "" })
      );
    }
  }

  const onChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const normalizeStatusSelection = (statusValues) => {
    if (
      statusValues.length === 0 ||
      statusValues.find((item) => item.key === STATUS_ALL) ||
      (statusDropdownOptions.length > 0 &&
        statusValues.length === statusDropdownOptions.length)
    ) {
      return "";
    }
    return statusValues.map((item) => item.key).join(",");
  };

  const loadList = (filters = {}) => {
    get_change_request_list(filters);
  };

  useEffect(() => {
    get_change_request_status_list();
    get_change_request_bulk_actions();
    loadList({});
  }, []);

  useEffect(() => {
    const statusOptions = (changeRequestStatusList || []).map((status) => ({
      key: status,
      cat: status,
    }));
    const allOption = { key: STATUS_ALL, cat: STATUS_ALL };
    const options = [allOption, ...statusOptions];
    setStatusDropdownOptions(options);
    const requestedOption = statusOptions.find((item) => item.key === STATUS_REQUESTED);
    if (requestedOption) {
      setSelectedStatuses([requestedOption]);
      loadList({ status: STATUS_REQUESTED });
    } else {
      setSelectedStatuses(options.length > 0 ? [...options] : []);
    }
  }, [changeRequestStatusList]);

  useEffect(() => {
    setTableData((changeRequestList || []).map((item) => ({ ...item, checked: false })));
  }, [changeRequestList]);

  const onSearch = (e) => {
    e.preventDefault();
    const splitedRef = state.refNum.split('-');
    const refNum = splitedRef.length > 1 ? splitedRef[1] : state.refNum;
    const filters = {
      refNum: refNum || undefined,
      clientId: state.clientId || undefined,
      clientName: state.clientName || undefined,
      workerId: state.workerId || undefined,
      workerName: state.workerName || undefined,
      completedBy: state.completedBy || undefined,
      status: normalizeStatusSelection(selectedStatuses) || undefined,
      from: setInputDate(state.from) || undefined,
      to: setInputDate(state.to) || undefined,
    };
    loadList(filters);
  };

  const onReset = () => {
    setState({ ...initialState });
    const requestedOption = statusDropdownOptions.find((item) => item.key === STATUS_REQUESTED);
    if (requestedOption) {
      setSelectedStatuses([requestedOption]);
      loadList({ status: STATUS_REQUESTED });
    } else {
      setSelectedStatuses([...statusDropdownOptions]);
      loadList({});
    }
  };

  const checkAll = (e) => {
    const checked = e.target.checked;
    setTableData((prev) => prev.map((row) => ({ ...row, checked })));
  };

  const onCheck = (refNum) => {
    setTableData((prev) =>
      prev.map((row) =>
        row.refNum === refNum ? { ...row, checked: !row.checked } : row
      )
    );
  };

  const isAllChecked = () => {
    if (tableData.length === 0) return false;
    return tableData.every((item) => item.checked);
  };

  const clearBulkActionSelection = () => {
    setState((prev) => ({ ...prev, bulkAction: "" }));
  };

  const onBulkActionChange = (e) => {
    const selectedAction = e.target.value;
    setState((prev) => ({ ...prev, bulkAction: selectedAction }));
    if (!selectedAction) return;

    const selectedRows = tableData.filter((item) => item.checked);
    if (selectedRows.length === 0) {
      setAlert("Please select records to perform bulk action", "danger");
      clearBulkActionSelection();
      return;
    }

    setNote("");
    setOpenModal(true);
  };

  const onConfirmBulkAction = async (e) => {
    e.preventDefault();
    const selectedRows = tableData.filter((item) => item.checked);
    if (selectedRows.length === 0) {
      setAlert("Please select records to perform bulk action", "danger");
      setOpenModal(false);
      clearBulkActionSelection();
      return;
    }

    const updated = await bulk_action_change_request({
      refNumList: selectedRows.map((row) => row.refNum),
      action: state.bulkAction,
      note,
    });

    if (updated) {
      setOpenModal(false);
      clearBulkActionSelection();
      const filters = {
        refNum: state.refNum || undefined,
        clientId: state.clientId || undefined,
        clientName: state.clientName || undefined,
        workerId: state.workerId || undefined,
        workerName: state.workerName || undefined,
        completedBy: state.completedBy || undefined,
        status: normalizeStatusSelection(selectedStatuses) || undefined,
        from: setInputDate(state.from) || undefined,
        to: setInputDate(state.to) || undefined,
      };
      loadList(filters);
    }
  };

  const toggleModal = () => {
    setOpenModal(!openModal);
    if (openModal) {
      clearBulkActionSelection();
    }
  };

  const tableColumns = [
    {
      Header: (
        <input type="checkbox" style={{ width: '16px', height: '16px', cursor: 'pointer' }} checked={isAllChecked()} onChange={checkAll} />
      ),
      accessor: "checkbox",
      sortable: false,
      maxWidth: 40,
      minWidth: 40,
      Cell: (row) => (
        <input
          type="checkbox"
          style={{ width: '16px', height: '16px', cursor: 'pointer' }}
          checked={!!row.original.checked}
          onChange={() => onCheck(row.original.refNum)}
        />
      ),
    },
    {
      Header: "Request ID",
      accessor: "refNum",
      minWidth: 110,
      Cell: (row) => row.original.refNum ? (
        <a
          href="/change-request"
          onClick={(e) => openChangeRequestInNewTab(e, row.original.refNum, row.original.clientName, row.original.workerName)}
          onContextMenu={(e) => onContextMenuChangeRequest(e, row.original.refNum, row.original.clientName, row.original.workerName)}
        >
          {`CHR-${row.original.refNum}`}
        </a>
      ) : <span>--</span>,
    },
    {
      Header: "Client ID",
      accessor: "clientId",
      minWidth: 80,
      Cell: (row) => row.original.clientId ? (
        <a
          href={`/sub-manage-client-profile/${row.original.clientId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.original.clientId}
        </a>
      ) : <span>--</span>,
    },
    {
      Header: "Client",
      accessor: "clientName",
      minWidth: 140,
      Cell: (row) => (
        <span className="w-100 text-left" title={row.original.clientName}>
          {row.original.clientName || "--"}
        </span>
      ),
    },
    {
      Header: "Worker ID",
      accessor: "workerId",
      minWidth: 80,
      Cell: (row) => row.original.workerId ? (
        <a
          href={`/manage-user-profile/${row.original.workerId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.original.workerId}
        </a>
      ) : <span>--</span>,
    },
    {
      Header: "Worker",
      accessor: "workerName",
      minWidth: 140,
      Cell: (row) => (
        <span className="w-100 text-left" title={row.original.workerName}>
          {row.original.workerName?.trim() || "--"}
        </span>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      minWidth: 90,
      className: "text-center",
      Cell: (row) => (
        <span className={getStatusClass(row.original.status)}>
          {row.original.status || "--"}
        </span>
      ),
    },
    {
      Header: "Requested Date",
      accessor: "requestedDate",
      minWidth: 125,
      Cell: (row) => setDateForTableInHrMinSec(row.original.requestedDate)|| "--",
    },
    {
      Header: "Completed On",
      accessor: "completedOn",
      minWidth: 125,
      Cell: (row) => setDateForTableInHrMinSec(row.original.completedOn) || "--",
    },
    {
      Header: "Completed By",
      accessor: "completedBy",
      minWidth: 120,
      Cell: (row) => (
        <span className="w-100 text-left" title={row.original.completedBy}>
          {row.original.completedBy || "--"}
        </span>
      ),
    },
    {
      Header: "Note",
      accessor: "note",
      minWidth: 140,
      Cell: (row) => (
        <span className="w-100 text-left" title={row.original.note}>
          {row.original.note || "--"}
        </span>
      ),
    },
  ];

  const { pageSize, pageSizeOptions } = state;
  const bulkActionOptions = (changeRequestBulkActions || []).map((item, i) => (
    <option key={`${item}-${i}`} value={item}>
      {item}
    </option>
  ));

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <CustomModal
        toggle={toggleModal}
        openModal={openModal}
        headerTitle="Change Request"
        footerComponent={
          <div className="w-100 d-flex justify-content-end">
            <Button type="submit" form="change-request-bulk-form" className="mx-2 px-4">
              Yes
            </Button>
            <Button type="button" onClick={toggleModal} className="mx-2 px-4">
              Cancel
            </Button>
          </div>
        }
        className="custom-modal"
        footerClasses="d-flex flex-row justify-content-center border-top-0"
      >
        <Form id="change-request-bulk-form" onSubmit={onConfirmBulkAction}>
          <Row className="p-3">
            <Col lg="12" className="pb-2">
              <label className="font-weight-bold">
                {`Are you sure you want to ${state.bulkAction} all selected Change Requests?`}
              </label>
            </Col>
            <Col lg="12" className="pb-2">
              <label className="mb-1">Note</label>
              <FormTextarea
                rows="4"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                placeholder={`${state.bulkAction}d by {user}`}
              />
            </Col>
          </Row>
        </Form>
      </CustomModal>

      <div className="page-header tableSearch flex-column flex-md-row py-2 d-flex justify-content-end bg-white mt-4">
        <div className="d-flex align-items-center p-2">
          <FormInput
            name="refNum"
            value={state.refNum}
            onChange={onChange}
            placeholder="Request ID"
          />
        </div>
        <div className="d-flex align-items-center p-2">
          <FormInput
            name="clientId"
            value={state.clientId}
            onChange={onChange}
            placeholder="Client ID"
          />
        </div>
        <div className="d-flex align-items-center p-2">
          <FormInput
            name="clientName"
            value={state.clientName}
            onChange={onChange}
            placeholder="Client"
          />
        </div>
        <div className="d-flex align-items-center p-2">
          <FormInput
            name="workerId"
            value={state.workerId}
            onChange={onChange}
            placeholder="Worker ID"
          />
        </div>
        <div className="d-flex align-items-center p-2">
          <FormInput
            name="workerName"
            value={state.workerName}
            onChange={onChange}
            placeholder="Worker"
          />
        </div>
        <div className="d-flex align-items-center p-2">
          <FormInput
            name="completedBy"
            value={state.completedBy}
            onChange={onChange}
            placeholder="Completed By"
          />
        </div>
        <div className="d-flex align-items-center p-2">
          <Multiselect
            hideSelectedList
            displayValue="key"
            placeholder={`Status: ${
              selectedStatuses.length > 0 &&
              (selectedStatuses.find((s) => s.key === STATUS_ALL) ||
                selectedStatuses.length === statusDropdownOptions.length)
                ? STATUS_ALL
                : selectedStatuses.map((val) => val.key).join(", ")
            }`}
            onKeyPressFn={function noAction() {}}
            onSearch={function noAction() {}}
            onRemove={(selectedOptions, removedItem) => {
              if (removedItem.key === STATUS_ALL) {
                setSelectedStatuses([]);
              } else {
                const options = selectedOptions.filter(
                  (option) => option.key !== STATUS_ALL
                );
                setSelectedStatuses(options);
              }
            }}
            onSelect={(selectedOptions, selectedItem) => {
              if (selectedItem.key === STATUS_ALL) {
                setSelectedStatuses([...statusDropdownOptions]);
              } else {
                if (selectedOptions.length === statusDropdownOptions.length - 1) {
                  selectedOptions = [...statusDropdownOptions];
                }
                setSelectedStatuses([...selectedOptions]);
              }
            }}
            options={[...statusDropdownOptions]}
            selectedValues={[...selectedStatuses]}
            showCheckbox
          />
        </div>
        <div className="d-flex align-items-center p-2">
          <InputGroup className={classNames("d-flex", "my-auto", "date-range")}>
            <DatePicker
              name="from"
              size="sm"
              selected={state.from}
              onChange={(date) => setState({ ...state, from: date })}
              dateFormat="yyyy-MM-dd"
              placeholderText="From"
              dropdownMode="select"
              autoComplete="off"
              className="text-center"
            />
            <DatePicker
              name="to"
              size="sm"
              selected={state.to}
              onChange={(date) => setState({ ...state, to: date })}
              dateFormat="yyyy-MM-dd"
              placeholderText="To"
              dropdownMode="select"
              autoComplete="off"
              className="text-center"
              popperPlacement="top-end"
            />
            <InputGroupAddon type="append">
              <InputGroupText>
                <i className="material-icons">&#xE916;</i>
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </div>
        <div className="d-flex align-items-center justify-content-end p-2">
          <Button
            className="mx-2 py-2 my-2"
            size="sm"
            name="Search"
            theme="accent"
            onClick={onSearch}
          >
            Search
          </Button>
          <Button className="mx-2 py-2 my-2" size="sm" theme="accent" onClick={onReset}>
            Reset
          </Button>
        </div>
      </div>

      <Card className="tableCard p-0">
        <CardHeader className="p-0">
          <Container fluid className="file-manager__filters border-bottom">
            <Row>
              <Col
                lg="2"
                className="file-manager__filters__rows d-flex justify-content-center justify-content-md-start align-items-center cl-2"
              >
                <span>
                  <FormSelect
                    size="sm"
                    name="bulkAction"
                    className="w-100"
                    value={state.bulkAction}
                    onChange={onBulkActionChange}
                  >
                    <option key="bulkActions0" value="">
                      Bulk Actions
                    </option>
                    {bulkActionOptions}
                  </FormSelect>
                </span>
              </Col>
              <Col lg="9" />
              <Col
                lg="1"
                className="file-manager__filters__rows d-flex justify-content-center justify-content-md-end align-items-center col-2"
              >
                <span>Show</span>
                <FormSelect
                  size="sm"
                  name="pageSize"
                  value={state.pageSize}
                  onChange={onChange}
                >
                  {pageSizeOptions.map((size, idx) => (
                    <option key={idx} value={size}>
                      {size} rows
                    </option>
                  ))}
                </FormSelect>
              </Col>
            </Row>
          </Container>
        </CardHeader>
        <CardBody className="p-0">
          <ReactTable
            columns={tableColumns}
            data={tableData}
            pageSize={Number(pageSize)}
            showPageSizeOptions={false}
            resizable={false}
            noDataText="No results found"
            previousText={<i class='fa fa-chevron-left' aria-hidden='true'></i>}
            nextText={<i class='fa fa-chevron-right' aria-hidden='true'></i>}
          />
        </CardBody>
      </Card>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  changeRequestList: state.changeRequest.changeRequestList,
  changeRequestBulkActions: state.changeRequest.changeRequestBulkActions,
  changeRequestStatusList: state.changeRequest.changeRequestStatusList,
});

export default connect(mapStateToProps, {
  get_change_request_list,
  get_change_request_status_list,
  get_change_request_bulk_actions,
  bulk_action_change_request,
  setAlert,
})(ChangeRequestList);
